import {
  Box,
  Button,
  CloseButton,
  Dialog,
  HStack,
  Heading,
  Portal,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import YearMonthPicker from "../../../../components/YearMonthPicker";
import { useDownloadSubscriptionReports } from "../hooks/useDownloadSubscriptionReports";

type Props = {
  open: boolean;
  onClose: () => void;
};

const MonthlyCostReportModal = ({ open, onClose }: Props): JSX.Element => {
  const { downloadMonthlyCostReport } = useDownloadSubscriptionReports();
  const [selectedMonth, setSelectedMonth] = useState<string | undefined>(
    undefined
  );
  const [isGenerating, setIsGenerating] = useState(false);

  const handleClose = () => {
    setSelectedMonth(undefined);
    onClose();
  };

  const handleGenerate = async () => {
    if (!selectedMonth) return;
    setIsGenerating(true);
    try {
      const { downloaded } = await downloadMonthlyCostReport(selectedMonth);
      if (downloaded) handleClose();
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(e) => !e.open && handleClose()}
      size="md"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content borderRadius="md" maxWidth="28rem">
            <Dialog.Header borderBottom="1px solid #ebecef80" padding="4">
              <Dialog.Title>
                <Heading>Reporte de pagos</Heading>
              </Dialog.Title>
            </Dialog.Header>
            <Dialog.CloseTrigger asChild>
              <CloseButton marginTop="1" onClick={handleClose} />
            </Dialog.CloseTrigger>
            <Dialog.Body py={6}>
              <VStack gap={4} align="stretch">
                <Box>
                  <Text fontWeight={600} mb={2}>
                    Mes de facturación
                  </Text>
                  <YearMonthPicker
                    placeholder="Seleccionar mes"
                    value={selectedMonth}
                    setValue={setSelectedMonth}
                  />
                </Box>
                <HStack gap={4} mt={4}>
                  <Button variant="outline" onClick={handleClose} flexGrow={1}>
                    Cancelar
                  </Button>
                  <Button
                    onClick={handleGenerate}
                    loading={isGenerating}
                    disabled={!selectedMonth}
                    flexGrow={1}
                  >
                    Generar
                  </Button>
                </HStack>
              </VStack>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default MonthlyCostReportModal;
